import { BoardSale } from "../../components/Graphics";

export const BoardOne = () => {
  return <BoardSale />;
};
